var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { produce } from "immer";
import { ACTIONS } from "../../actions/enchancers/filterable.actions";
import { FilterGroupTypes } from "../../feature/tint-editor/components/tint-editor/top-bar-filter/filter-modal/tint-editor-top-bar-filter-modal";
export const initialState = {
  selectedFilters: {}
};
export function filterable(reducer, config, initialState2) {
  const _config = __spreadValues(__spreadValues({}, ACTIONS), config);
  return (state = initialState2, action) => {
    switch (action.type) {
      case _config.SET_FILTERS:
        return produce(state, (draft) => {
          draft.selectedFilters = __spreadProps(__spreadValues({}, draft.selectedFilters), {
            [action.payload.type]: action.payload.type !== FilterGroupTypes.DATE ? action.payload.data.sort((a, b) => a > b ? 1 : -1) : action.payload.data.length !== 0 ? action.payload.data : void 0
          });
        });
      case _config.CLEAR_FILTERS:
        return produce(state, (draft) => {
          draft.selectedFilters = {};
        });
      default:
        return reducer(state, action);
    }
  };
}
